module.exports = __webpack_public_path__ + "img/nodata.c74ce544.png";